import { render, staticRenderFns } from "./BooleanInput.vue?vue&type=template&id=66b703db&"
import script from "./BooleanInput.vue?vue&type=script&lang=js&"
export * from "./BooleanInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports